import React from 'react';
import MapChart from './index';

/**
 * 基础用法 Demo
 * 展示世界地图组件的基本使用方式，传入各国数据即可渲染
 */
const BasicDemo: React.FC = () => {
  const mockData = [
    { name: 'China', value: 8345 },
    { name: 'United States', value: 6243 },
    { name: 'Japan', value: 5120 },
    { name: 'Germany', value: 3987 },
    { name: 'United Kingdom', value: 3456 },
    { name: 'France', value: 2934 },
    { name: 'Brazil', value: 2789 },
    { name: 'India', value: 2134 },
    { name: 'Italy', value: 1987 },
    { name: 'Canada', value: 1654 },
  ];

  return (
    <MapChart
      style={{ width: '100%', height: 500 }}
      loading={false}
      data={mockData}
    />
  );
};

/**
 * 自定义 tooltip 用法 Demo
 * 展示如何使用自定义 tooltip formatter 来控制气泡浮窗内容
 */
const CustomTooltipDemo: React.FC = () => {
  const mockData = [
    { name: 'China', value: 8345 },
    { name: 'United States', value: 6243 },
    { name: 'Japan', value: 5120 },
    { name: 'Germany', value: 3987 },
    { name: 'United Kingdom', value: 3456 },
  ];

  const customTooltipFormatter = (params: any) => {
    if (!params?.data) {
      return '';
    }
    const { name, value } = params.data;
    const displayValue = value != null ? value.toLocaleString() : '-';
    return `
      <div style="padding: 8px 12px;">
        <div style="font-weight: 500;">${name}</div>
        <div style="color: #666; margin-top: 4px;">数值: ${displayValue}</div>
      </div>
    `;
  };

  return (
    <MapChart
      style={{ width: '100%', height: 500 }}
      loading={false}
      data={mockData}
      tooltipFormatter={customTooltipFormatter}
    />
  );
};

export const demoConfig = [
  {
    title: '基础用法',
    description: '传入各国数据，渲染世界地图并展示数据分段配色',
    code: `<MapChart
  style={{ width: '100%', height: 500 }}
  loading={false}
  data={[
    { name: 'China', value: 8345 },
    { name: 'United States', value: 6243 },
    { name: 'Japan', value: 5120 },
  ]}
/>`,
    element: <BasicDemo />,
  },
  {
    title: '自定义 Tooltip',
    description: '通过 tooltipFormatter 自定义气泡浮窗的内容格式',
    code: `<MapChart
  style={{ width: '100%', height: 500 }}
  loading={false}
  data={mockData}
  tooltipFormatter={(params) => {
    const { name, value } = params.data;
    return \`<div>\${name}: \${value}</div>\`;
  }}
/>`,
    element: <CustomTooltipDemo />,
  },
];

export default demoConfig;
